export default "__VITE_ASSET__B4fN533r__"